import PropTypes from "prop-types";
import React, {Component} from 'react';
import {Button, Modal} from "react-bootstrap";
import {connect} from "react-redux";

import {getLanguages} from "../../redux/actions";
import EditableText from "./EditableText";
import FieldGroup from "../FieldGroup";

class AddTranslationKeyModal extends Component {
    constructor(props) {
        super(props);
        props.dispatch(getLanguages());
        this.state = {
            key: "", value: ""
        };
    }

    i18nKeyChanged(e) {
        this.setState({
            key: e.target.value,
            error: undefined
        });
    }

    i18nValueKeyChanged(e) {
        this.setState({
            value: e.target.value,
            error: undefined
        });
    }

    render() {
        return (
            <Modal show={this.props.visible} onHide={e => this.props.onModalChange({visible: false})}>
                <Modal.Header closeButton>
                    <Modal.Title>Add i18n key</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h3>Add i18n key to the master language</h3>
                    <FieldGroup
                        checked={this.state.key}
                        id="i18n_key"
                        placeholder="Technical i18n key"
                        type="text"
                        onChange={e => this.i18nKeyChanged(e)}
                        label="i18n key"
                    />
                    <FieldGroup
                        checked={this.state.value}
                        id="i18n_value"
                        placeholder="Human readable string for the base language"
                        type="text"
                        onChange={e => this.i18nValueKeyChanged(e)}
                        label="i18n value"
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" onClick={e => this.props.onSave({...this.state})}>Save</Button>
                    <Button onClick={e => this.props.onModalChange({visible: false})}>Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

EditableText.propTypes = {
    visible: PropTypes.bool.isRequired,
    onSave: PropTypes.func.isRequired,
    onModalChange: PropTypes.func.isRequired
};

export default connect(null, (dispatch) => ({dispatch}))(AddTranslationKeyModal);



// WEBPACK FOOTER //
// ./src/components/languages/AddTranslationKeyModal.js